import {createReducer} from "typesafe-actions";
import {SELECT_TOURNAMENT_MENU} from "../actions";

export const tournamentsIDReducer = createReducer<number | 'rating' | 'home' | null>('home')
    .handleAction(SELECT_TOURNAMENT_MENU, (state, action) => action.payload);